import React from "react";
import "./InvestAfrica.scss";

const offerings = [
    {
        number: "01",
        title: "Market Entry",
        description:
            "Explore new markets with local insight and a clear path from opportunity to action.",
    },
    {
        number: "02",
        title: "Strategic Partnerships",
        description:
            "Connect with businesses and partners aligned with your ambitions.",
    },
    {
        number: "03",
        title: "Project Development",
        description:
            "Shape promising ideas into practical initiatives through technology and collaboration.",
    },
];

const InvestAfrica = () => {
    return (
        <section
            className="invest-africa"
            id="invest-africa"
            aria-labelledby="invest-africa-title"
        >
            <div className="invest-africa__inner">
                <div className="invest-africa__content">
                    <p className="invest-africa__eyebrow">
                        Techadive Invest Africa
                    </p>

                    <h2 id="invest-africa-title">
                        Connecting Global Innovation with{" "}
                        <span>African Opportunity.</span>
                    </h2>

                    <p className="invest-africa__description">
                        We connect international businesses with opportunities across
                        Africa, bringing together technology, market insight, and
                        strategic relationships to help ideas move forward.
                    </p>

                    <a className="invest-africa__button" href="/invest-africa">
                        Discover Invest Africa
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>

                <div className="invest-africa__opportunities">
                    <div className="invest-africa__label">
                        <span className="invest-africa__label-dot" aria-hidden="true" />
                        From connection to collaboration
                    </div>

                    <ul className="invest-africa__list">
                        {offerings.map((offering) => (
                            <li className="invest-africa__item" key={offering.number}>
                <span className="invest-africa__number" aria-hidden="true">
                  {offering.number}
                </span>

                                <div>
                                    <h3>{offering.title}</h3>
                                    <p>{offering.description}</p>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <p className="invest-africa__note">
                        Global perspective. Local connections. Shared ambition.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default InvestAfrica;